export const INTERNAL_CHAT_PANEL_UI_FLAG = 'is_internal_chat_panel_open';

export const INTERNAL_CHAT_PERMISSIONS = [
  'administrator',
  'agent',
  'internal_chat_manage',
];

export const ACTIVE_CHANNEL_STORAGE_KEY =
  'alibsoft_internal_chat_panel_channel_id';

export function openInternalChatPanel(updateUISettings) {
  updateUISettings({
    is_internal_chat_panel_open: true,
    is_contact_sidebar_open: false,
    is_copilot_panel_open: false,
  });
}

export function closeInternalChatPanel(updateUISettings) {
  updateUISettings({
    is_internal_chat_panel_open: false,
  });
}

export function toggleInternalChatPanel(updateUISettings, isOpen) {
  if (isOpen) {
    closeInternalChatPanel(updateUISettings);
    return;
  }
  openInternalChatPanel(updateUISettings);
}
